import React from 'react';



const Files = ()=>{
    return(
        <div>Soooo many files</div>
    )
}



export default Files;